import {Component, ViewChild} from '@angular/core';
import {NavController, NavParams, Slides} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {ProfilePagePage} from "../profile-page/profile-page";
import {ProfileService} from "../../../providers/profile-service";
import {CONFIG} from "../../../app/config";

import 'rxjs/add/operator/map';
import {MessageService} from "../../../providers/message-service";
import {TAction, TChavecoFlag, TContatoTipo, TFollowup} from "../../../app/enum";
import {DataService} from "../../../providers/data-service";
import {LogadoService} from "../../../providers/logado-service";
import {ProfileFotoPage} from "../profile-foto/profile-foto";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {WebstorService} from "../../../providers/webstor-service";
import {PrivacyMenuPage} from "../privacy-menu/privacy-menu";

@Component({
    selector: 'page-chaveco-menu',
    templateUrl: 'chaveco-menu.html',
    providers: [ProfileService, ProfileRepository, WebstorService]
})

export class ChavecoMenuPage {

    TFollowup: any = TFollowup;
    TChavecoFlag: any = TChavecoFlag;

    config: any;
    etapa: number;

    logado: any;
    profile: any;

    chavecos: any;
    chavecu: any;

    drawerOptions: any;

    slides: any[];
    slideIndex: number;

    selected: any;

    myself: boolean;

    @ViewChild(Slides) slider: Slides;

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams,
                public dataService: DataService, public messageService: MessageService,
                public logadoService: LogadoService,
                public profileService: ProfileService, public profileRepository: ProfileRepository,
                public webstorService: WebstorService) {


        this.config = CONFIG;
        this.etapa = this.navParams.get('etapa');

        this.logado = this.logadoService.getAuth();
        this.profile = this.navParams.get('profile');
        this.chavecu = this.navParams.get('chaveco');

        this.selected = null;
        this.myself = (this.logado.Profile.ProfileID == this.profile.ProfileID);

        this.drawerOptions = {
            handleHeight: 0,
            thresholdFromBottom: (window.innerHeight * 0.5),
            thresholdFromTop: 0,
            bounceBack: true,
            show: true
        };


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Pedir Whats', '/chaveco-menu');

        if (this.etapa == 0) this.hashtagLoad();
        if (this.etapa == 1) this.chavecoLoad();
        if (this.etapa == 2) this.chavecoFind();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);
        //if (this.slider) this.slider.slideTo(1, 0);

    }

    hashtagLoad() {

        if (!this.dataService.get('chavecos.loaded')) {

            let loading = this.util.loadingDots();
            loading.present();

            this.webstorService.hashtag(TAction.acLoad)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {

                        this.dataService.set('chavecos.loaded', data.Hashtags);
                        this.slides = data.Hashtags;

                    },
                    erro => {

                        this.util.alertResult(erro, () => this.dismiss());

                    }
                );

        }
        else {

            this.slides = this.dataService.get('chavecos.loaded');

            //Remove seleçao antiga
            this.hashtagSeta(null);

        }


        if (!this.chavecu) {
            this.chavecu = {ChavecoFlag: TChavecoFlag.chNull, Hashtag: null};
        }


    }

    chavecoLoad() {

        //Contatinho, fica escutando...
        this.subscribeChaveco();


        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.chaveco(TAction.acLoad, this.profile.ProfileID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.chavecos = data.Chavecos,
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    chavecoFind() {

        if (this.chavecu) return;

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.chaveco(TAction.acFind, this.profile.ProfileID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    if (data.Chavecos.length) {
                        this.profile = data.Chavecos[0].Profile;
                        this.chavecu = data.Chavecos[0].Chaveco;
                        return;
                    }

                    this.dismiss();

                },
                erro => {

                    this.util.alertResult(erro, () => this.dismiss());

                }
            );

    }

    chavecoLixo() {

        let onLixo = () => {

            let loading = this.util.loadingDots();
            loading.present();

            this.profileService.chaveco(TAction.acLixo, this.profile.ProfileID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {
                        /*this.chavecu.Hashtag     = null;
                        this.chavecu.ChavecoQuem = false;
                        this.chavecu.ChavecoFlag = TChavecoFlag.chNull;
                        this.chavecu.ChavecoChip = '';*/
                        this.messageService.get('chaveco.edit').next({profile: this.profile, chaveco: null});
                        this.dismiss(true);
                    },
                    erro => this.util.alertResult(erro)
                );

        };

        if (this.chavecu.ChavecoFlag == TChavecoFlag.chRequest) onLixo();

        if (this.chavecu.ChavecoFlag == TChavecoFlag.chAceitou) {
            let alerta = 'Vocês não visualizarão mais o número do Whatsapp.';
            this.util.alertQuestion('Deseja revogar?', alerta, 'Continuar', () => onLixo(), false, true);
        }

    }

    chavecoLove(chavecoFlag: TChavecoFlag) {

        //Responder
        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.chaveco(TAction.acLove, this.profile.ProfileID, 0, this.chavecu.Hashtag.HashtagID, chavecoFlag)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    let whatsbool = (chavecoFlag == TChavecoFlag.chRecusou);
                    this.chavecu.Hashtag     = (whatsbool ? null : this.chavecu.Hashtag);
                    this.chavecu.ChavecoQuem = (whatsbool ? false : this.chavecu.ChavecoQuem);
                    this.chavecu.ChavecoFlag = (whatsbool ? TChavecoFlag.chNull : TChavecoFlag.chAceitou);
                    this.chavecu.ChavecoChip = (whatsbool ? '' : data.ChavecoChip);

                    this.messageService.get('chaveco.edit').next({profile: this.profile, chaveco: this.chavecu});

                    this.dismiss(true);

                },
                erro => {

                    this.util.alertResult(erro);

                });

    }

    chavecoSend(event) {

        this.profileService.chaveco(TAction.acLove, this.profile.ProfileID, 0, this.selected.HashtagID, TChavecoFlag.chRequest)
            .finally(() => event.cancelLoader())
            .subscribe(
                data => {

                    this.chavecu.Hashtag = this.selected;
                    this.chavecu.ChavecoQuem = true;
                    this.chavecu.ChavecoFlag = TChavecoFlag.chRequest;

                    this.messageService.get('chaveco.edit').next({profile: this.profile, chaveco: this.chavecu});

                    this.dismiss(true);

                },
                erro => {

                    this.util.alertResult(erro);

                });

    }


    sliderMove(event) {

        this.slideIndex = this.slider.getActiveIndex();
        this.hashtagSeta(null);

    }

    hashtagSeta(hashteg) {

        if (this.slides) {
            this.slides.forEach(hashtag => {
                hashtag.Hashtags.forEach(hashtog => {
                    if (hashtog != hashteg) hashtog.selected = false;
                });
            });
        }

        if (hashteg) hashteg.selected = !hashteg.selected;
        this.selected = (this.selected == hashteg ? null : hashteg);

    }

    friendyMigo(event, profile) {

        this.profileRepository.friendy(event, TAction.acMigo, profile).subscribe(data => {}, erro => {});

    }

    chavecoMenu(chaveco, $event) {

        if ($event) $event.stopPropagation();

        let object = {etapa: 0, profile: chaveco.Profile, chaveco: chaveco};
        this.navCtrl.push(ChavecoMenuPage, object, {animate: false});

    }

    chavecoList() {

        //Esta na Foto Myself ativando Privacy Mostra Contatinho
        //Serve somente para isso essa funcao
        let contatinho = (this.myself && this.logado.Profile.PrivacyChip);
        if (!contatinho) return;

        let object = {etapa: 1, profile: this.logado.Profile, chaveco: null};
        this.navCtrl.push(ChavecoMenuPage, object).then(() => this.navCtrl.getPrevious().dismiss());

    }

    profilePage(profile) {

        //Meus Whats
        if (this.etapa == 1) {
            let object = {profileID: profile.ProfileID};
            this.navCtrl.push(ProfilePagePage, object);
            return;
        }

        //Está em CheckinMenuPage
        if (this.dataService.get('tabselected') == 1) {
            let object = {profileID: profile.ProfileID};
            this.navCtrl.push(ProfilePagePage, object).then(() => this.navCtrl.getPrevious().dismiss());
            return;
        }

        this.dismiss();

    }

    privacyMenu() {

        let copy = this.util.deepCopy(this.logado);

        let object = {etapa: 4, rootile: this.logado, copyile: copy};
        this.util.modalopen(PrivacyMenuPage, 'quad', true, object)
            .finally(() => this.chavecoList())
            .subscribe();

    }

    pictureEdit() {

        let copy = this.util.deepCopy(this.logado);
        let objectData = {etapa: 1, rootile: this.logado, copyile: copy};
        this.util.modalopen(ProfileFotoPage, 'wide', false, objectData).subscribe();

    }

    dismiss(anime?) {

        let object = (!anime ? null : {animation: 'md-transition'});
        this.navCtrl.pop(object);

    }

    subscribeChaveco() {

        this.messageService.get('chaveco.edit')
            .subscribe(data => {

                let indexCV = this.chavecos.findIndex(CV => CV.Profile.ProfileID == data.profile.ProfileID);
                if (indexCV >= 0) {
                    if (!data.chaveco) this.chavecos.splice(indexCV, 1);
                    if (data.chaveco)  this.util.populateObj(this.chavecos[indexCV], data.chaveco);
                }

            });

    }





    /** ************************************************* SETTING ************************************************* **/
    /** ************************************************* etapa-1 ************************************************* **/

    contatoOpen() {

        let contato = {ContatoRede: TContatoTipo.coChip, ContatoUser: this.chavecu.ChavecoChip};
        this.profileRepository.contatoOpen(contato, false, this.profile);

    }


}



// WEBPACK FOOTER //
// ./src/pages/sync/chaveco-menu/chaveco-menu.ts